import { render } from "./DataItem.vue?vue&type=template&id=a9faf35a"
import script from "./DataItem.vue?vue&type=script&lang=js"
export * from "./DataItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__